import { createIcon } from '@chakra-ui/icons';

export const Export = createIcon({
  displayName: 'Export',
  viewBox: '0 0 13 16',
  path: [
    <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.55371 0.519684H6.92285V11.1291H5.55371V0.519684Z" fill="currentColor" />
      <path
        d="M5.28467 0.395467C5.7788 -0.0986684 6.56132 -0.129903 7.09131 0.302693L7.19385 0.395467L10.0552 3.25679L8.97705 4.3359L6.23877 1.59762L3.50146 4.3359L2.42334 3.25679L5.28467 0.395467Z"
        fill="currentColor"
      />
      <path
        d="M0 13.1823V7.70668C0 6.52943 0.954589 5.57484 2.13184 5.57484H4.26269V7.10023H2.13184C1.79701 7.10023 1.52539 7.37185 1.52539 7.70668V13.1823C1.52554 13.517 1.7971 13.7877 2.13184 13.7877H10.3447C10.6795 13.7877 10.951 13.517 10.9512 13.1823V7.70668C10.9512 7.37185 10.6796 7.10023 10.3447 7.10023H8.21289V5.57484H10.3447C11.522 5.57484 12.4766 6.52943 12.4766 7.70668V13.1823C12.4764 14.3594 11.5219 15.3131 10.3447 15.3131H2.13184C0.954683 15.3131 0.000152537 14.3594 0 13.1823Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
